export const ADD_DAILY_COMMISSION_REQUEST = 'ADD_DAILY_COMMISSION_REQUEST';
export const ADD_DAILY_COMMISSION_SUCCESS = 'ADD_DAILY_COMMISSION_SUCCESS';
export const ADD_DAILY_COMMISSION_FAIL = 'ADD_DAILY_COMMISSION_FAIL';
export const ADD_DAILY_COMMISSION_RESET = 'ADD_DAILY_COMMISSION_RESET';

export const GET_DAILY_COMMISSIONS_REQUEST = 'GET_DAILY_COMMISSIONS_REQUEST';
export const GET_DAILY_COMMISSIONS_SUCCESS = 'GET_DAILY_COMMISSIONS_SUCCESS';
export const GET_DAILY_COMMISSIONS_FAIL = 'GET_DAILY_COMMISSIONS_FAIL';
export const GET_DAILY_COMMISSIONS_RESET = 'GET_DAILY_COMMISSIONS_RESET';

export const GET_DAILY_COMMISSION_BY_ID_REQUEST = 'GET_DAILY_COMMISSION_BY_ID_REQUEST';
export const GET_DAILY_COMMISSION_BY_ID_SUCCESS = 'GET_DAILY_COMMISSION_BY_ID_SUCCESS';
export const GET_DAILY_COMMISSION_BY_ID_FAIL = 'GET_DAILY_COMMISSION_BY_ID_FAIL';
export const GET_DAILY_COMMISSION_BY_ID_RESET = 'GET_DAILY_COMMISSION_BY_ID_RESET';

export const UPDATE_DAILY_COMMISSION_REQUEST = 'UPDATE_DAILY_COMMISSION_REQUEST';
export const UPDATE_DAILY_COMMISSION_SUCCESS = 'UPDATE_DAILY_COMMISSION_SUCCESS';
export const UPDATE_DAILY_COMMISSION_FAIL = 'UPDATE_DAILY_COMMISSION_FAIL';
export const UPDATE_DAILY_COMMISSION_RESET = 'UPDATE_DAILY_COMMISSION_RESET';

export const DELETE_DAILY_COMMISSION_REQUEST = 'DELETE_DAILY_COMMISSION_REQUEST';
export const DELETE_DAILY_COMMISSION_SUCCESS = 'DELETE_DAILY_COMMISSION_SUCCESS';
export const DELETE_DAILY_COMMISSION_FAIL = 'DELETE_DAILY_COMMISSION_FAIL';
export const DELETE_DAILY_COMMISSION_RESET = 'DELETE_DAILY_COMMISSION_RESET';

export const GET_COMMISSION_SUMMARY_REQUEST = 'GET_COMMISSION_SUMMARY_REQUEST';
export const GET_COMMISSION_SUMMARY_SUCCESS = 'GET_COMMISSION_SUMMARY_SUCCESS';
export const GET_COMMISSION_SUMMARY_FAIL = 'GET_COMMISSION_SUMMARY_FAIL';
export const GET_COMMISSION_SUMMARY_RESET = 'GET_COMMISSION_SUMMARY_RESET';

// ===== NEW: Evidence Status Update =====
export const UPDATE_EVIDENCE_STATUS_REQUEST = 'UPDATE_EVIDENCE_STATUS_REQUEST';
export const UPDATE_EVIDENCE_STATUS_SUCCESS = 'UPDATE_EVIDENCE_STATUS_SUCCESS';
export const UPDATE_EVIDENCE_STATUS_FAIL = 'UPDATE_EVIDENCE_STATUS_FAIL';
export const UPDATE_EVIDENCE_STATUS_RESET = 'UPDATE_EVIDENCE_STATUS_RESET';

// ===== NEW: Bulk Evidence Status Update =====
export const BULK_UPDATE_EVIDENCE_STATUS_REQUEST = 'BULK_UPDATE_EVIDENCE_STATUS_REQUEST';
export const BULK_UPDATE_EVIDENCE_STATUS_SUCCESS = 'BULK_UPDATE_EVIDENCE_STATUS_SUCCESS';
export const BULK_UPDATE_EVIDENCE_STATUS_FAIL = 'BULK_UPDATE_EVIDENCE_STATUS_FAIL';
export const BULK_UPDATE_EVIDENCE_STATUS_RESET = 'BULK_UPDATE_EVIDENCE_STATUS_RESET';

// ===== NEW: Export Commissions =====
export const EXPORT_DAILY_COMMISSIONS_REQUEST = 'EXPORT_DAILY_COMMISSIONS_REQUEST';
export const EXPORT_DAILY_COMMISSIONS_SUCCESS = 'EXPORT_DAILY_COMMISSIONS_SUCCESS';
export const EXPORT_DAILY_COMMISSIONS_FAIL = 'EXPORT_DAILY_COMMISSIONS_FAIL';